
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M21.502 19.525C23.026 18.42 24 16.787 24 14.971c0-3.326-3.237-6.023-7.229-6.023s-7.229 2.697-7.229 6.023c0 3.327 3.237 6.024 7.229 6.024.825 0 1.621-.117 2.36-.33l.212-.032c.139 0 .265.043.384.111l1.583.914.139.045a.241.241 0 00.241-.241l-.039-.176-.326-1.215-.025-.154a.48.48 0 01.202-.392zM8.675 2.297C3.884 2.297 0 5.533 0 9.526c0 2.178 1.168 4.139 2.997 5.464a.575.575 0 01.243.471l-.03.184-.391 1.458-.047.211c0 .16.13.29.289.29l.168-.054 1.899-1.097a.908.908 0 01.46-.133l.255.038c.886.255 1.842.397 2.832.397l.476-.012a5.586 5.586 0 01-.291-1.771c0-3.641 3.542-6.593 7.911-6.593l.471.012c-.653-3.453-4.24-6.094-8.567-6.094zm5.686 11.711a.964.964 0 11.001-1.927.964.964 0 01-.001 1.927zm4.82 0a.964.964 0 110-1.928.964.964 0 010 1.928zM5.783 8.369a1.156 1.156 0 110-2.312 1.156 1.156 0 010 2.312zm5.783 0a1.156 1.156 0 110-2.312 1.156 1.156 0 010 2.312z"}})])
          )
        }
      }
    